import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Firebase configuration object
const firebaseConfig = {
  apiKey: 'AIzaSyBe0EwMO1Id8Fo0lRM1HVpR12zxyfZNOnc',
  authDomain: 'iyuga-7f31e.firebaseapp.com',
  projectId: 'iyuga-7f31e',
  storageBucket: 'iyuga-7f31e.firebasestorage.app',
  messagingSenderId: '828252184616',
  appId: '1:828252184616:web:8277287ee1a99d2c86951d',
  measurementId: 'G-FQ0GSD3YNJ',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize messaging conditionally based on browser support
let messaging = null;

// Function to initialize messaging safely
const initializeMessaging = async () => {
  try {
    // Check if Firebase messaging is supported in this browser
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
      console.log('Firebase messaging initialized successfully');
    } else {
      console.log('Firebase messaging not supported in this browser');
    }
  } catch (error) {
    console.warn('Failed to initialize Firebase messaging:', error);
  }
};

// Initialize messaging immediately
initializeMessaging();

/**
 * Request notification permission and retrieve FCM token.
 */
const requestNotificationPermission = async () => {
  try {
    // Check if messaging was successfully initialized
    if (!messaging) {
      console.log('Firebase messaging not available');
      return null;
    }

    // Check if Notification API is available
    if (!('Notification' in window)) {
      console.log('Notification API not supported');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey:
          'BJKnKWPgogNr6I513LAe6aeAilu4KjHgrYWTlrc4md3euzIuTD8LFGTQDHf8Am6LzLfw9HcINAyKlIGd42hD9i8',
      });
      console.log('FIREBASE == FCM Token:', token); // Send this token to your backend
      return token;
    } else {
      console.log('FIREBASE == Notification permission denied.');
      return null;
    }
  } catch (error) {
    console.warn('FIREBASE == Error requesting notification permission:', error);
    return null;
  }
};

/**
 * Listen for foreground push notifications.
 * @param {Function} callback - Function to handle incoming messages.
 */
const onMessageListener = (callback) => {
  if (!messaging) {
    console.log('Firebase messaging not available, skipping message listener');
    return;
  }

  try {
    onMessage(messaging, (payload) => {
      console.log('FIREBASE == Foreground notification received:', payload);
      if (callback) callback(payload);
    });
  } catch (error) {
    console.warn('Error setting up message listener:', error);
  }
};

export { messaging, requestNotificationPermission, onMessageListener };

// const PushNotification = () => {
//     useEffect(() => {
//       requestNotificationPermission();

//       // Handle incoming messages when the app is in the foreground
//       onMessage(messaging, (payload) => {
//         console.log("Message received:", payload);
//         alert(`Notification: ${payload.notification.title}`);
//       });
//     }, []);

//     return <div>Firebase Push Notifications Setup</div>;
//   };

//   export default PushNotification;
